/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-09-27 15:40:56
 * @LastEditTime: 2020-09-27 15:42:10
 * @Description: 销售记录api
 */
import axios from '@/utils/axios'

export const getSalesRecordList = (payload) => {
    return axios.get('/salesRecord', {
        params: payload
    })
}

// 获取销售标签
export const getSalesRecordTags = (payload) => {
    return axios.get('/salesRecordTags', {
        params: payload
    })
}

export const getSalesRecordByID = (id) => {
    return axios.get(`/salesRecord/${id}`)
}

export const updateSalesRecord = (id, data) => {
    return axios.put(`/salesRecord/${id}`, data)
}

export const createSalesRecord = (data) => {
    return axios.post(`/salesRecord`, data)
}